import React, { useContext, useEffect, useState, useRef } from "react";
import { useSiteMetadata } from "../hooks/useSiteMetadata";
import { useGviconfigurator } from "../hooks/useSiteConfigurator";

export const ThemeContext = React.createContext({
  colorMode: process.env.GATSBY_DEFAULT_THEME,
  localeLanguage: "",
  currentDomain: "",
  currentBrand: "",
  planetDomain: "",
  peopleDomain: "",
  currentSiteMeta: {},
  isLive: false,
  site: {}
});

export const ThemeProvider = ({ children }) => {
  const colorMode = process.env.GATSBY_DEFAULT_THEME;
  const currentBrand = process.env.GATSBY_PROJECT_NAV_TITLE.toLowerCase();
  const localeLanguage =
    process.env.GATSBY_PROJECT_LOCALE_LANGUAGE?.toLowerCase() || "us";

  const site = useSiteMetadata();

  const [isLive, setIsLive] = useState(false); //we are using for now, to determine what pages use new template - its temporary (6 months temporary).

  const configurator = useGviconfigurator();
  // console.log("useGviconfigurator", { localLang, configurator });

  const siteMetadataRef = useRef();

  siteMetadataRef.current = configurator?.world_contact_details[localeLanguage];

  const currentSiteMeta = siteMetadataRef?.current;
  const currentDomain = siteMetadataRef?.current?.domain;
  const planetDomain = currentDomain;
  const peopleDomain = currentDomain;

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    const url = new URL(window?.location ?? location);

    if (
      !url?.host?.includes("netlify.app") &&
      !url?.host?.includes("gatsbyjs.io") &&
      !url?.host?.includes("gviworld.com") &&
      !url?.host?.includes("localhost")
    ) {
      setIsLive(true);
    }
  }, []);

  // console.debug("testing values", {
  //   colorMode,
  //   siteMetadata: siteMetadataRef.current,
  //   currentDomain,
  //   currentSiteMeta,
  //   currentBrand,
  //   planetDomain,
  //   peopleDomain,
  //   localeLanguage: localLang,
  //   isLive
  // });

  return (
    <ThemeContext.Provider
      value={{
        colorMode,
        currentDomain,
        currentSiteMeta,
        currentBrand,
        planetDomain,
        peopleDomain,
        site,
        localeLanguage,
        isLive
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

/**
 * Notes: must be run in a useEffect, otherwise it will not work
 * process traffic source
 *  **/

export const processTrafficSource = () => {};

export const useTheme = () => {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error("useTheme should be used in ThemeContext provider");
  }

  return context;
};
